import { Routes, Route } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { onAuthStateChanged, signInAnonymously, User } from 'firebase/auth'
import { auth } from './services/firebase'
import { AuthProvider } from './context/AuthContext'
import Layout from './components/Layout'
import HomePage from './pages/HomePage'
import WritePage from './pages/WritePage'
import ReadPage from './pages/ReadPage'
import SpecialReadPage from './pages/SpecialReadPage'
import LoadingScreen from './components/LoadingScreen'
import { logAnonymousSignIn } from './services/analytics'

function App() {
  const [user, setUser] = useState<User | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let hasTriedAnonymousSignIn = false

    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      // If there's no user yet, try silent anonymous sign-in once
      if (!currentUser && !hasTriedAnonymousSignIn) {
        hasTriedAnonymousSignIn = true
        try {
          await signInAnonymously(auth)
          logAnonymousSignIn()
          // Wait for the next auth state change (with the new anonymous user)
          return
        } catch (error) {
          console.error('Silent anonymous sign-in failed:', error)
          // Fall through and show the app without a signed-in user
        }
      }

      setUser(currentUser)
      setLoading(false)
    })

    return () => unsubscribe()
  }, [])

  if (loading) {
    return <LoadingScreen />
  }

  return (
    <AuthProvider value={{ user, loading }}>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/write" element={<WritePage />} />
          <Route path="/read" element={<ReadPage />} />
          <Route path="/special" element={<SpecialReadPage />} />
        </Routes>
      </Layout>
    </AuthProvider>
  )
}

export default App
